import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutQuoteStopTable extends Layout {
    buttonAddAnotherStop: Button;
    panelStopContainer: Panel;
    sourceQuoteStop: DataSource;
    tableStop: Table;
}
